import { LANGUAGE_CODE } from "../i18n";

const PORT = !!process.env.PORT ? `:${process.env.PORT}` : "";

// Privacy policy is published in Italian and English. Pick the version that
// matches the language already detected from the browser locale (same logic the
// whole app uses for i18n); fall back to English for any non-Italian locale.
const PRIVACY_INFO_BY_LANG = {
  it: "https://light-speed.it/privacy-policy/",
  en: "https://light-speed.it/en/privacy-policy/",
};
const PRIVACY_INFO_URL =
  PRIVACY_INFO_BY_LANG[LANGUAGE_CODE] || PRIVACY_INFO_BY_LANG.en;

const API_URL = process.env.API_URL || `${window.location.hostname}`;
const API_PROTOCOL = process.env.API_PROTOCOL;
const WS_PROTOCOL = process.env.WS_PROTOCOL;
const API_BASE = `${API_PROTOCOL}://${API_URL}${PORT}`;
const WS_BASE = `${WS_PROTOCOL}://${API_URL}${PORT}`;

console.log("Api base:", API_BASE);
console.log("WS base:", WS_BASE);

export default {
  API_BASE,
  DASHBOARD_BASE: "/training",
  SENSORS_BASE: "/race",
  ALARMS_BASE: "/alarms",
  IMAGES_BASE: "/images",
  NOTIFICATIONS_BASE: "/notifications",
  SETTINGS_BASE: "/settings",
  CONFIGURATION_BASE: "/configuration",
  LOGIN: "/login",
  CHANGE_PASSWORD: "/change-password",
  PASSWORD_RESET: "/password-reset",
  PASSWORD_RESET_CONFIRM: "/password-reset/confirm",
  DEV_TEST: "/dev-test",
  NOT_FOUND_DEFAULT: "/not-found",
  WS_BASE,
  WS_PERIODIC_STATUSES_BASE: "/periodic-statuses/",
  PRIVACY_INFO: PRIVACY_INFO_URL,
};
